import { LabelSize } from "./Label.types";

/** Semantic UI label scale (smaller than button/input SIZE_FONT). */
export const LABEL_FONT_SIZE: Record<LabelSize, string> = {
  small: "0.7rem",
  medium: "0.85rem",
  large: "1rem",
};
